import styled from "styled-components";

export const StyledMainMobileContainer = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-template-rows: max-content;
  grid-row-gap: 15px;
  justify-items: center;
`;

export const StyledImageContainer = styled.div`
  margin-top: 15px;
  position: relative;
  width: 100%;
  height: 247px;
  svg {
    position: absolute;
    width: 100%;
    height: 100%;
  }
`;

export const StyledTitle = styled.p`
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  color: #264445;
`;

export const StyledDescription = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #797a80;
  line-height: 30px;
  text-align: center;
  span {
    margin-right: 10px;
  }
`;
